export default __webpack_public_path__ + "static/media/sticker_upload_guide_kiki.7f9d44cc.png";